import { categories } from "@/mocks/homeData";
import SectionHeader from "./SectionHeader";

export default function CategoryGrid() {
  return (
    <section id="category" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <SectionHeader
          align="center"
          eyebrow="瓜田分区"
          title="六块瓜地 想逛哪块逛哪块"
          desc="按内容类型分好类，表情包、沙雕图、梗图、头像、壁纸和周边衍生各归其位，快速直达你最需要的那一档。"
        />
        <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
          {categories.map((cat) => (
            <a
              key={cat.key}
              href={`#${cat.key}`}
              className="group relative block overflow-hidden rounded-2xl bg-background-100 aspect-[4/5] cursor-pointer"
            >
              <img
                src={cat.img}
                alt={`${cat.name}专区预览图`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/10 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 flex flex-col items-start p-3.5 text-left">
                <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-background-50/90 text-accent-700">
                  <i className={`${cat.icon} text-xl`} />
                </span>
                <h3 className="mt-2 font-heading text-lg leading-none text-background-50">{cat.name}</h3>
                <p className="mt-1 text-xs text-background-50/85">{cat.desc}</p>
              </div>
              <span className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full bg-secondary-500 text-foreground-950 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                <i className="ri-arrow-right-up-line" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}